import {
  ProductPurchaseOption,
  ProductPurchaseType,
} from 'content/products';
import { M1_Switzerland, M1_Iceland } from 'content/products/m1/EU';
import { NewM1Data } from 'content/products/m1/IN';
import { Currency } from 'utils/Currency';

type localeDataType = {
  name: string;
  currency: Currency;
  defaultOption: ProductPurchaseOption;
  defaultProduct: ProductPurchaseType;
};

/**
 * @deprecated Use isMCFCountry() from utils/countryUtils instead.
 *
 * COUNTRY_STORE_CONFIG is now the single source of truth for MCF configuration.
 * Countries are marked with m1Config: { mcf: true } in COUNTRY_STORE_CONFIG.
 *
 * Migration:
 * - Instead of MCF_Countries.includes(locale), use isMCFCountry(locale)
 */
export const MCF_Countries = [
  'at',
  'be',
  'bg',
  'hr',
  'cy',
  'cz',
  'dk',
  'ee',
  'fi',
  'fr',
  'de',
  'gr',
  'hu',
  'ie',
  'it',
  'lv',
  'lt',
  'lu',
  'mt',
  'nl',
  'pl',
  'pt',
  'ro',
  'sk',
  'si',
  'es',
  'se',
  'gb',
];

export const supportedLocales: Record<string, localeDataType> = {
  ch: {
    name: 'Switzerland',
    currency: Currency.ch,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  // EU 👇🏼
  is: {
    name: 'Iceland',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_2_weeks_eu,
  },
  at: {
    name: 'Austria',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  be: {
    name: 'Belgium',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  bg: {
    name: 'Bulgaria',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  hr: {
    name: 'Croatia',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  cy: {
    name: 'Cyprus',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  cz: {
    name: 'Czech Republic',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  dk: {
    name: 'Denmark',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  ee: {
    name: 'Estonia',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  fi: {
    name: 'Finland',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  fr: {
    name: 'France',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  de: {
    name: 'Germany',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  gr: {
    name: 'Greece',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  hu: {
    name: 'Hungary',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  ie: {
    name: 'Ireland',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  it: {
    name: 'Italy',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  lv: {
    name: 'Latvia',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  lt: {
    name: 'Lithuania',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  lu: {
    name: 'Luxembourg',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  nl: {
    name: 'Netherlands',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  pl: {
    name: 'Poland',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  pt: {
    name: 'Portugal',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  ro: {
    name: 'Romania',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  sk: {
    name: 'Slovakia',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  si: {
    name: 'Slovenia',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  es: {
    name: 'Spain',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  se: {
    name: 'Sweden',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  gb: {
    name: 'United Kingdom',
    currency: Currency.gbp,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  mc: {
    name: 'Monaco',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  mt: {
    name: 'Malta',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
  no: {
    name: 'Norway',
    currency: Currency.eur,
    defaultOption: ProductPurchaseOption.oneTimePurchase,
    defaultProduct: ProductPurchaseType.otp_4_weeks_eu,
  },
};

export const productToLocaleMapper: Record<string, NewM1Data> = {
  ch: M1_Switzerland,
  is: M1_Iceland,
};
